<div class="dark-mode" *ngrxLet="isDarkMode$ as isDarkMode">
    <mat-slide-toggle [checked]="isDarkMode" (change)="setDarkMode(!isDarkMode)">
        <div class="dark-mode-toggle" [class.dark-mode-active]="isDarkMode">
            <dtm-ui-icon class="dark-mode-toggle-icon" name="sun-fill" *ngIf="!isDarkMode"></dtm-ui-icon>
            <dtm-ui-icon class="dark-mode-toggle-icon" name="moon-fill" *ngIf="isDarkMode"></dtm-ui-icon>
        </div>
    </mat-slide-toggle>
</div>
